import { __assign, __rest } from "tslib";
import React, { useMemo } from 'react';
import { Box, NumberInput, NumberInputField } from '@chakra-ui/react';
var CommaNumberField = function (_a) {
    var name = _a.name, props = __rest(_a, ["name"]);
    var precision = props.precision || 0;
    var _b = React.useState(props.defaultValue || 0), value = _b[0], setValue = _b[1];
    var isWithinRange = useMemo(function () {
        if (props.max && props.min) {
            return value >= props.min && value <= props.max;
        }
        return false;
    }, [props, value]);
    var handleNumberInputChange = function (valueNumber) {
        setValue(valueNumber);
        if (props === null || props === void 0 ? void 0 : props.onChange) {
            props.onChange(valueNumber.toString(), valueNumber);
        }
    };
    var format = function (valueAsNumber) {
        var valueAsString = valueAsNumber.toString();
        var _a = valueAsString.split('.'), integerPart = _a[0], _b = _a[1], decimalPart = _b === void 0 ? '' : _b;
        if (decimalPart) {
            valueAsString = "".concat(integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.'), ",").concat(decimalPart.padEnd(precision, '0'));
        }
        else {
            valueAsString = "".concat(integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.'), ",").concat('0'.repeat(precision));
        }
        return valueAsString;
    };
    var parse = function (valueAsString) {
        var valueAsNumber;
        try {
            var parsedValueAsString = valueAsString.replace(/\D/g, '');
            parsedValueAsString = parsedValueAsString.padStart(precision + 1, '0');
            parsedValueAsString = "".concat(parsedValueAsString.substring(0, parsedValueAsString.length - precision), ".").concat(parsedValueAsString.slice(precision * -1));
            valueAsNumber = parseFloat(parsedValueAsString);
        }
        catch (_a) {
            valueAsNumber = 0;
        }
        return valueAsNumber;
    };
    return (React.createElement(Box, { mt: 2, w: '100%' },
        React.createElement(NumberInput, __assign({ id: name, type: 'decimal', borderColor: 'primary', variant: 'outline', placeholder: props.placeholder, size: 'md', isInvalid: !isWithinRange, clampValueOnBlur: false, keepWithinRange: false }, { name: name }, props, { 
            // order is important keep onChange bellow the received props
            value: format(value), onChange: function (valueAsString) { return handleNumberInputChange(parse(valueAsString)); } }),
            React.createElement(NumberInputField, { bg: 'background.default' }))));
};
export default CommaNumberField;
//# sourceMappingURL=CommaNumberField.js.map